<template>
  <Layout>
    <PageTitle />

    <div class="page-padding page-padding-all">
      <UiButtonAdd title="Добавить сотрудника" :to="{ name: 'manager-create' }" />

      <ManagersTable />
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'
import ManagersTable from './managersTable/ManagersTable.vue'
import UiButtonAdd from '@/components/UiButtonAdd.vue'

export default {
  page: {
    title: 'Сотрудники',
  },
  components: {
    Layout,
    PageTitle: () => import('./PageTitle.vue'),
    ManagersTable,
    UiButtonAdd,
  },
}
</script>
